import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Dialog from './Dialog';
import styles from '../../styles/contacts/ContactsWorkspace.module.css';

export default function MeetUpgradeDialog({ open, onClose }) {
  const navigate = useNavigate();
  const primaryRef = useRef(null);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Upgrade to Pro"
      lead="Meet and automated follow-ups are included with Pro. Join the waitlist to hear when Pro becomes available."
      initialFocusRef={primaryRef}
      footer={
        <div className={styles.dialogFoot}>
          <button type="button" className={`${styles.btn} ${styles.btnGhost}`} onClick={onClose}>
            Not now
          </button>
          <button
            ref={primaryRef}
            type="button"
            className={`${styles.btn} ${styles.btnPrimary}`}
            onClick={() => {
              onClose?.();
              navigate('/upgrade?focus=pro');
            }}
          >
            View Pro plan
          </button>
        </div>
      }
    />
  );
}
